import { render } from "./couponsandMessages.vue?vue&type=template&id=04e14159&scoped=true"
import script from "./couponsandMessages.vue?vue&type=script&lang=js"
export * from "./couponsandMessages.vue?vue&type=script&lang=js"

import "./couponsandMessages.vue?vue&type=style&index=0&id=04e14159&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e14159"]])

export default __exports__